(()=>{
  const init=root=>{
    if(root.dataset.lxcReady)return;
    const first=root.querySelector('[data-lxc-first]'),second=root.querySelector('[data-lxc-second]');
    if(!first||!second)return;
    let previousFirst=first.value,previousSecond=second.value;
    const mobile=window.matchMedia('(max-width:699px)');
    const update=changed=>{
      if(first.value===second.value){
        if(changed===first)second.value=previousFirst;else first.value=previousSecond;
      }
      root.querySelectorAll('[data-lxc-model]').forEach(cell=>cell.toggleAttribute('data-lxc-excluded',![first.value,second.value].includes(cell.dataset.lxcModel)));
      root.querySelectorAll('tr').forEach(row=>{
        const order=mobile.matches?[first.value,second.value,...['aura','como','tora'].filter(m=>![first.value,second.value].includes(m))]:['aura','como','tora'];
        order.forEach(model=>{const cell=row.querySelector('[data-lxc-model="'+model+'"]');if(cell)row.append(cell);});
      });
      previousFirst=first.value;previousSecond=second.value;
    };
    root.dataset.lxcReady='true';root.classList.add('lxc-ready');root.querySelector('.lxc-pair').hidden=false;
    first.addEventListener('change',()=>update(first));second.addEventListener('change',()=>update(second));mobile.addEventListener('change',()=>update());update();
  };
  document.querySelectorAll('[data-lxc]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lxc]').forEach(init));
})();
